import trilliant from "../Assets/TS Logo-1.png";
import errorPageImg from "../Assets/lottie/page_error.lottie";
import error404 from "../Assets/svg/Error404.svg";
import AppLogo from "../Assets/Retail-Logo.jpg";
import NoProfile from "../Assets/NoProfile.jpeg";
import textLogo from "../Assets/logo.png";

export const AppImages = {
  trilliant,
  errorPageImg,
  error404,
  AppLogo,
  NoProfile,
  textLogo,
};
